module.exports = __webpack_public_path__ + "img/default_2x.c48e306c.svg";